import { format, toZonedTime } from 'date-fns-tz';
import { es } from 'date-fns/locale';

const ZONA_HORARIA = 'America/Argentina/Buenos_Aires';

/**
 * Formatea una fecha ISO al formato local dd-MM-yyyy HH:mm:ss
 * usando la zona horaria de Argentina.
 */
export const formatearFecha = (fechaISO) => {
  const horaLocal = toZonedTime(new Date(fechaISO), ZONA_HORARIA);
  return format(horaLocal, 'dd-MM-yyyy HH:mm:ss', {
    timeZone: ZONA_HORARIA,
    locale: es,
  });
};
